(function ($, document, window) {
    'use strict';

    const initModal = () => {
        const $trigger = $('.js-modal-trigger');
        const $target = $('.js-modal-target');
        const $container = $('.js-modal-container');
        const $close = $('.js-modal-close');
        const $bodyOverlay = $('.js-body-overlay');
        const activeClass = 'is-active';
        let currentModalIndex = 0;

        const getModalParam = () => {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('scholar');
        }

        const setModalParam = (value) => {
            const url = new URL(window.location);
            url.searchParams.set('scholar', value);
            window.history.pushState({}, '', url);
        }

        const removeModalParam = () => {
            const url = new URL(window.location);
            url.searchParams.delete('scholar');
            window.history.pushState({}, '', url);
        }

        const handleOpen = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const id = $(e.currentTarget).data('modal');
            currentModalIndex = $trigger.index(e.currentTarget);

            showModal(id);
            setModalParam(id);
        }

        const handleClose = () => {
            $target.removeClass(activeClass).attr('aria-hidden', true);
            $('body').removeClass('u-overflow-hidden');
            $bodyOverlay.removeClass(activeClass);
            $bodyOverlay.attr('aria-hidden', true);
            $(document).off('click', handleOutsideClick);
            $(document).off('keydown', handleEscapeKey);
            $trigger.eq(currentModalIndex).blur();
            removeModalParam();
        }

        const handleOutsideClick = (e) => {
            if (!$(e.target).closest($container).length) {
                handleClose();
            }
        }

        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        }

        const showModal = (id) => {
            $(`#${id}`).addClass(activeClass).attr('aria-hidden', false);
            $('body').addClass('u-overflow-hidden');
            $bodyOverlay.addClass(activeClass);
            $bodyOverlay.attr('aria-hidden', false);

            setTimeout(() => {
                $(document).on('click', handleOutsideClick);
                $(document).on('keydown', handleEscapeKey);
            }, 0);
        }

        const showModalFromParam = () => {
            const modalId = getModalParam();

            if (modalId && $(`#${modalId}`).length) {
                const $modalTrigger = $trigger.filter(`[data-modal="${modalId}"]`);

                if ($modalTrigger.length) {
                    currentModalIndex = $trigger.index($modalTrigger.first());
                }

                showModal(modalId);
            }
        };

        $trigger.on('click', handleOpen);
        $close.on('click', handleClose);

        showModalFromParam();
    };

    const updateModals = (postIds) => {
        if (!postIds || postIds.length === 0) return;

        $.ajax({
            url: rb.ajax_url,
            type: 'POST',
            data: {
                action: 'rb_ajax_get_page_modals',
                nonce: rb.nonce,
                post_ids: postIds
            },

            // If the request was successful and the modal HTML was returned...
            success: function (response) {
                if (response.success && response.data.modal_html) {
                    // Remove the existing modals.
                    $('.js-modal-target').remove();

                    // Add the new modals to the body.
                    $('body').append(response.data.modal_html);

                    // Reinitialise the modal functionality.
                    initModal();
                }
            },

            // If the request failed, reinitialise the modal functionality.
            error: function (xhr, status, error) {
                initModal();
            }
        });
    };

    let previousPageState = null;

    $(document).on('facetwp-loaded', function () {
        // setTimeout with a small delay to ensure FacetWP has fully updated.
        setTimeout(() => {
            const currentPageState = {
                url: window.location.href,
                page: FWP.facets.pager ? FWP.facets.pager.page : 1,
            };

            // Check if the current page state is different from the previous page state.
            const isPaginationChange = previousPageState &&
                (currentPageState.page !== previousPageState.page ||
                    currentPageState.url !== previousPageState.url);

            // If the pagination has changed...
            if (isPaginationChange) {
                const postIds = [];

                // Collect the up to date post IDs from the current page.
                $('.js-modal-trigger').each(function () {
                    const postId = $(this).data('post-id');

                    // If the post ID is set and not already in the array...
                    if (postId && postIds.indexOf(postId) === -1) {
                        // Add the post ID to the array.
                        postIds.push(postId);
                    }
                });

                // Update the modals for the stored post IDs.
                updateModals(postIds);
            } else {
                // If the pagination has not changed, reinitialise the modal functionality.
                initModal();
            }

            previousPageState = currentPageState;
        }, 100);
    });

    initModal();
})(jQuery, document, window);
